import google_logo_icon from "../../../img/google_icon.svg";
import { FormattedMessage, useIntl } from "react-intl";
import facebook_logo_icon from "../../../img/facebook_logo.svg";
import React from "react";
import { Button, Box, useTheme } from "@mui/material";

export const RegisterSocialButtons = ({
  onOpenSSOSidebar,
}) => {
  const intl = useIntl();
  const theme = useTheme();

  const handleGoogleClick = () => {
    onOpenSSOSidebar("google");
  };

  const handleFacebookClick = () => {
    onOpenSSOSidebar("facebook");
  };

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 2, width: '100%' }}>
      <Button
        onClick={handleGoogleClick}
        variant="outlined"
        startIcon={
          <img 
            src={google_logo_icon} 
            alt="Google"
            style={{ width: '20px', height: '20px' }}
          />
        }
        sx={{
          width: '100%',
          maxWidth: '320px',
          height: '48px',
          textTransform: 'none',
          fontSize: '14px',
          fontWeight: 600,
          color: theme.palette.grey[700],
          borderColor: 'rgba(232, 121, 117, 0.2)',
          borderRadius: '12px',
          padding: '12px 20px',
          backgroundColor: 'rgba(255, 255, 255, 0.8)',
          backdropFilter: 'blur(10px)',
          border: '2px solid rgba(232, 121, 117, 0.1)',
          boxShadow: '0 2px 8px rgba(0, 0, 0, 0.05)',
          '&:hover': {
            borderColor: 'rgba(232, 121, 117, 0.4)',
            backgroundColor: 'rgba(255, 255, 255, 0.95)',
            transform: 'translateY(-1px)',
            boxShadow: '0 4px 15px rgba(0, 0, 0, 0.1)',
          },
          transition: 'all 0.3s ease',
        }}
      >
        <FormattedMessage id="sign-up.continue-with-google" />
      </Button>

      <Button
        onClick={handleFacebookClick}
        variant="outlined"
        startIcon={
          <img 
            src={facebook_logo_icon} 
            alt="Facebook"
            style={{ width: '20px', height: '20px' }}
          />
        }
        sx={{
          width: '100%',
          maxWidth: '320px',
          height: '48px',
          textTransform: 'none',
          fontSize: '14px',
          fontWeight: 600,
          color: theme.palette.grey[700],
          borderColor: 'rgba(232, 121, 117, 0.2)',
          borderRadius: '12px',
          padding: '12px 20px',
          backgroundColor: 'rgba(255, 255, 255, 0.8)',
          backdropFilter: 'blur(10px)',
          border: '2px solid rgba(232, 121, 117, 0.1)',
          boxShadow: '0 2px 8px rgba(0, 0, 0, 0.05)',
          '&:hover': {
            borderColor: 'rgba(232, 121, 117, 0.4)',
            backgroundColor: 'rgba(255, 255, 255, 0.95)',
            transform: 'translateY(-1px)',
            boxShadow: '0 4px 15px rgba(0, 0, 0, 0.1)',
          },
          transition: 'all 0.3s ease',
        }}
      >
        <FormattedMessage id="sign-up.continue-with-facebook" />
      </Button>
    </Box>
  );
};

